import { Controller } from "@hotwired/stimulus"

// Lets the reader fold the contents column down to a slim rail, giving the article the room, and remembers the choice in this browser.
export default class extends Controller {
  static targets = ["button"]
  static values = { key: String }

  connect() {
    this.set(this.stored())
  }

  toggle() {
    const collapsed = !this.element.classList.contains("is-toc-collapsed")
    this.set(collapsed)
    try { localStorage.setItem(this.keyValue, collapsed ? "1" : "0") } catch (_error) { /* not remembered */ }
  }

  set(collapsed) {
    this.element.classList.toggle("is-toc-collapsed", collapsed)
    this.buttonTargets.forEach((button) => {
      const label = collapsed ? "Show contents" : "Hide contents"
      button.setAttribute("aria-expanded", String(!collapsed))
      button.setAttribute("aria-label", label)
      button.title = label
    })
  }

  stored() {
    try { return localStorage.getItem(this.keyValue) === "1" } catch (_error) { return false }
  }
}
